// ============================================
// ADMIN PANEL - Funcionalidades con BDD Real
// ============================================

let currentAdminTab = 'dashboard';
let adminUsers = [];
let adminSubs = [];
let adminLogs = [];
let adminRecentActivities = [];
let adminActivityPage = 1;
const ADMIN_ACTIVITY_PAGE_SIZE = 5;
let adminUsersPage = 1;
let adminSubsPage = 1;
let adminLogsPage = 1;
let adminPlansPage = 1;
let adminInstallationsPage = 1;
let adminArchivedPage = 1;
let adminDiscountsPage = 1;
const ADMIN_USERS_PAGE_SIZE = 5;
const ADMIN_SUBS_PAGE_SIZE = 5;
const ADMIN_LOGS_PAGE_SIZE = 5;
const ADMIN_PLANS_PAGE_SIZE = 5;
const ADMIN_INSTALLATIONS_PAGE_SIZE = 5;
const ADMIN_ARCHIVED_PAGE_SIZE = 5;
const ADMIN_DISCOUNTS_PAGE_SIZE = 5;
let adminUsersFiltered = [];
let adminSubsFiltered = [];
let adminLogsFiltered = [];
let adminPlansList = [];
let adminInstallationsList = [];
let adminArchivedAccounts = [];
let adminDiscounts = [];
let adminDiscountsFiltered = [];
let adminSessionTimeout = null;
let adminStartTime = null;
const ADMIN_SESSION_DURATION = 15 * 60 * 1000; // 15 minutos en milisegundos
const ADMIN_SESSION_KEY = 'adminSessionStart';
const ADMIN_TOKEN_KEY = 'adminToken';

// Helper para obtener el worker URL
function getAdminWorkerUrl() {
    return window.WORKER_URL || 'https://trading-journal-preprod.monkeydfx-trader.workers.dev';
}

// Helper para ejecutar queries SQL via admin token
// NOT exposed to window (prevents console access)
async function adminQuery(sql, args = []) {
    const adminToken = window._adminToken;
    if (!adminToken) {
        throw new Error('No hay token de admin. Inicia sesión como admin primero.');
    }
    
    const workerUrl = getAdminWorkerUrl();
    const response = await fetch(`${workerUrl}/api/execute`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${adminToken}`
        },
        body: JSON.stringify({ sql, args })
    });
    
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: response.statusText }));
        throw new Error(errorData.error || 'Query failed');
    }
    
    return response.json();
}

/**
 * Iniciar sesión admin - Establece temporizador de 15 minutos
 */
window.startAdminSession = function() {
    adminStartTime = Date.now();
    sessionStorage.setItem(ADMIN_SESSION_KEY, adminStartTime.toString());
    // Guardar token para persistir entre páginas
    if (window._adminToken) {
        sessionStorage.setItem(ADMIN_TOKEN_KEY, window._adminToken);
    }
    startAdminSessionTimer();
};

/**
 * Verificar si hay sesión admin activa
 */
window.checkAdminSession = function() {
    const savedStart = sessionStorage.getItem(ADMIN_SESSION_KEY);
    const savedToken = sessionStorage.getItem(ADMIN_TOKEN_KEY);
    
    if (!savedStart || !savedToken) {
        // Limpiar ambos si falta alguno
        sessionStorage.removeItem(ADMIN_SESSION_KEY);
        sessionStorage.removeItem(ADMIN_TOKEN_KEY);
        return false;
    }
    
    const startTime = parseInt(savedStart, 10);
    const elapsed = Date.now() - startTime;
    
    if (elapsed < ADMIN_SESSION_DURATION) {
        adminStartTime = startTime;
        // Restaurar token en memoria
        window._adminToken = savedToken;
        return true;
    }
    
    // Sesión expirada - limpiar todo
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
    sessionStorage.removeItem(ADMIN_TOKEN_KEY);
    window._adminToken = null;
    return false;
};

/**
 * Restaurar sesión admin si está activa
 */
window.restoreAdminSession = function() {
    if (window.checkAdminSession()) {
        const adminModal = document.getElementById('adminModal');
        if (adminModal) {
            const wasMinimized = sessionStorage.getItem('adminMinimized') === 'true';
            
            if (wasMinimized) {
                // Restaurar estado minimizado
                adminModal.classList.add('show');
                adminModal.classList.add('minimized');
                adminModal.style.display = 'flex';
                
                const windowContent = document.getElementById('adminWindowContent');
                if (windowContent) {
                    windowContent.classList.add('minimized');
                }
                const navBar = document.getElementById('adminNavBar');
                if (navBar) navBar.style.display = 'none';
                const draggableWindow = document.querySelector('.admin-draggable-window');
                if (draggableWindow) {
                    draggableWindow.classList.add('minimized');
                }
                document.querySelectorAll('#adminModal .admin-panel').forEach(p => p.style.display = 'none');
                const minimizeBtn = document.getElementById('adminMinimizeBtn');
                if (minimizeBtn) minimizeBtn.textContent = '+';
                
                // No inicializar el panel si está minimizado
                startAdminSessionTimer();
            } else {
                // Restaurar estado normal
                adminModal.classList.add('show');
                adminModal.style.display = 'flex';
                if (window.initAdminPanel) window.initAdminPanel();
            }
        }
        return true;
    }
    return false;
};

/**
 * Actualizar temporizador de sesión
 */
function startAdminSessionTimer() {
    const timerElement = document.getElementById('adminSessionTimer');
    
    const updateTimer = () => {
        if (!adminStartTime) return;
        
        const elapsed = Date.now() - adminStartTime;
        const remaining = Math.max(0, ADMIN_SESSION_DURATION - elapsed);
        
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        
        if (timerElement) {
            timerElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        }
        
        if (remaining <= 0) {
            closeAdminSession();
            return;
        }
        
        adminSessionTimeout = setTimeout(updateTimer, 1000);
    };
    
    updateTimer();
}

/**
 * Cerrar sesión admin cuando expira
 */
function closeAdminSession() {
    if (adminSessionTimeout) clearTimeout(adminSessionTimeout);
    adminStartTime = null;
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
    sessionStorage.removeItem(ADMIN_TOKEN_KEY);
    window._adminToken = null;
    
    const adminModal = document.getElementById('adminModal');
    if (adminModal) {
        adminModal.classList.remove('show');
        adminModal.style.display = 'none';
        adminModal.setAttribute('aria-hidden', 'true');
    }
    
    showAdminNotification('⏱️ Sesión de administrador expirada (15 minutos)', 'warning');
}

/**
 * Toggle visibilidad de contraseña
 */
window.toggleAdminPasswordVisibility = function() {
    const input = document.getElementById('adminPassword');
    const btn = event.target;
    
    if (input.type === 'password') {
        input.type = 'text';
        btn.textContent = '🙈';
    } else {
        input.type = 'password';
        btn.textContent = '👁️';
    }
};

/**
 * Manejar login del admin - validar contraseña y abrir panel
 */
window.handleAdminLogin = async function(event) {
    event.preventDefault();
    
    const password = document.getElementById('adminPassword').value;
    if (!password) return;

    try {
        // Usar window.verifyAdminPassword que está en app.js
        if (typeof window.verifyAdminPassword !== 'function') {
            showAdminNotification('Error: Sistema no listo', 'error');
            return;
        }

        const result = await window.verifyAdminPassword(password);
        
        if (result.success) {
            // Guardar token y marcar como admin
            window._adminToken = result.token;
            localStorage.setItem('userType', 'admin');
            
            showAdminNotification('Acceso concedido', 'success');
            
            // Cerrar modal de autenticación
            const authModal = document.getElementById('adminAuthModal');
            if (authModal) {
                authModal.classList.remove('show');
            }
            
            // Abrir panel admin
            setTimeout(() => {
                const adminModal = document.getElementById('adminModal');
                if (adminModal) {
                    adminModal.classList.add('show');
                    adminModal.style.display = 'flex';
                    
                    // Inicializar sesión
                    window.startAdminSession();
                    loadAdminDashboard();
                } else {
                    showAdminNotification('Panel admin no disponible', 'warning');
                }
            }, 300);
        } else {
            showAdminNotification(` ${result.error || 'Contraseña incorrecta'}`, 'error');
            document.getElementById('adminPassword').value = '';
        }
    } catch (error) {
        showAdminNotification('Error en la autenticación', 'error');
        document.getElementById('adminPassword').value = '';
    }
};

/**
 * Mostrar notificación en el admin panel
 */
function showAdminNotification(message, type = 'info') {
    if (typeof window.showAlert === 'function') {
        window.showAlert('Panel Admin', message, type, 3000);
    }
}

/**
 * Draggable deshabilitado - modal fijo centrado
 */
function makeAdminWindowDraggable() {
    return;
}

/**
 * Minimizar/Restaurar panel admin
 */
window.toggleAdminMinimize = function() {
    const modal = document.getElementById('adminModal');
    const content = document.getElementById('adminWindowContent');
    const navBar = document.getElementById('adminNavBar');
    const minimizeBtn = document.getElementById('adminMinimizeBtn');
    
    if (modal.classList.contains('minimized')) {
        modal.classList.remove('minimized');
        content.classList.remove('minimized');
        if (navBar) navBar.style.display = 'flex';
        document.querySelectorAll('#adminModal .admin-panel').forEach(p => p.style.display = 'none');
        document.getElementById('dashboardPanel').style.display = 'block';
        if (minimizeBtn) minimizeBtn.textContent = '−';
        sessionStorage.setItem('adminMinimized', 'false');
    } else {
        modal.classList.add('minimized');
        content.classList.add('minimized');
        if (navBar) navBar.style.display = 'none';
        document.querySelectorAll('#adminModal .admin-panel').forEach(p => p.style.display = 'none');
        if (minimizeBtn) minimizeBtn.textContent = '+';
        sessionStorage.setItem('adminMinimized', 'true');
    }
};

/**
 * Cerrar panel admin
 */
window.closeAdminModal = function() {
    const modal = document.getElementById('adminModal');
    if (modal) {
        modal.classList.remove('show');
        modal.style.display = 'none';
        modal.classList.remove('minimized');
        modal.setAttribute('aria-hidden', 'true');
    }
    if (adminSessionTimeout) clearTimeout(adminSessionTimeout);
    adminStartTime = null;
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
    sessionStorage.removeItem(ADMIN_TOKEN_KEY);
    sessionStorage.removeItem('adminMinimized');
    window._adminToken = null;
};

/**
 * Cambiar entre pestañas
 */
window.switchAdminTab = function(tabName) {
    // Ocultar todos los paneles DENTRO del admin modal
    document.querySelectorAll('#adminModal .admin-panel').forEach(panel => {
        panel.style.display = 'none';
    });
    
    // Desactivar todos los botones
    document.querySelectorAll('#adminModal .admin-tab-btn').forEach(btn => {
        btn.classList.remove('active');
    });
    
    // Mostrar panel seleccionado
    const panelId = tabName + 'Panel';
    const panel = document.getElementById(panelId);
    if (panel) {
        panel.style.display = 'block';
    }
    
    // Activar botón
    document.querySelector(`#adminModal [data-admin-tab="${tabName}"]`)?.classList.add('active');
    currentAdminTab = tabName;
    
    // Cargar datos específicos de la pestaña
    if (tabName === 'dashboard') {
        loadAdminDashboard();
    } else if (tabName === 'users') {
        loadAdminUsers();
    } else if (tabName === 'subscriptions') {
        loadAdminSubscriptions();
    } else if (tabName === 'discounts') {
        loadAdminDiscounts();
    } else if (tabName === 'archived') {
        loadAdminArchivedAccounts();
    } else if (tabName === 'sync') {
        if (typeof window.adminRefreshInstallations === 'function') {
            window.adminRefreshInstallations();
        } else {

        }
    } else if (tabName === 'logs') {
        loadAdminLogs();
    }
};

// ============================================
// DASHBOARD - Estadísticas reales desde BDD
// ============================================
async function loadAdminDashboard() {
    const totalUsersEl = document.getElementById('totalUsers');
    const activeUsersEl = document.getElementById('activeUsers');
    const activeSubsEl = document.getElementById('activeSubs');
    const monthlyRevenueEl = document.getElementById('monthlyRevenue');
    const activityList = document.getElementById('recentActivityList');
    
    try {
        // Cargar estadísticas reales - solo usuarios ACTIVOS con planes de pago y suscripciones NO EXPIRADAS
        const [usersResult, activeResult, activeSubsResult] = await Promise.all([
            adminQuery('SELECT COUNT(*) as total FROM users'),
            adminQuery('SELECT COUNT(*) as total FROM users WHERE is_active = 1'),
            adminQuery(`SELECT COUNT(DISTINCT id) as total FROM users 
                        WHERE (user_plan = "pro" OR user_plan = "unlimited") 
                        AND is_active = 1 
                        AND expires_at > datetime('now')`)
        ]);
        
        const totalUsers = usersResult.rows?.[0]?.total || 0;
        const activeUsers = activeResult.rows?.[0]?.total || 0;
        const activeSubs = activeSubsResult.rows?.[0]?.total || 0;
        
        if (totalUsersEl) totalUsersEl.textContent = totalUsers;
        if (activeUsersEl) activeUsersEl.textContent = activeUsers;
        if (activeSubsEl) activeSubsEl.textContent = activeSubs;
        
        // Calcular ingresos mensuales reales basados en suscripciones activas
        const subsDetailResult = await adminQuery(`
            SELECT user_plan, COUNT(*) as count 
            FROM users 
            WHERE (user_plan = "pro" OR user_plan = "unlimited") 
            AND is_active = 1 
            AND expires_at > datetime('now')
            GROUP BY user_plan
        `);
        
        let estimatedRevenue = 0;
        if (subsDetailResult.rows) {
            subsDetailResult.rows.forEach(row => {
                if (row.user_plan === 'pro') {
                    estimatedRevenue += row.count * 9.99;
                } else if (row.user_plan === 'unlimited') {
                    estimatedRevenue += row.count * 14.99;
                }
            });
        }
        
        if (monthlyRevenueEl) monthlyRevenueEl.textContent = `$${estimatedRevenue.toFixed(2)}`;
        
        // Cargar actividades recientes mixtas (registros y logins)
        const recentActivity = await adminQuery(`
            SELECT 
                email, 
                created_at, 
                last_login,
                user_plan, 
                is_active,
                CASE 
                    WHEN last_login IS NOT NULL THEN last_login
                    ELSE created_at
                END as activity_date
            FROM users 
            ORDER BY activity_date DESC 
            LIMIT 20
        `);
        
        if (activityList && recentActivity.rows) {
            const activities = [];
            
            recentActivity.rows.forEach(user => {
                const hasLoggedIn = !!user.last_login;
                const createdDate = new Date(user.created_at);
                const loginDate = user.last_login ? new Date(user.last_login) : null;
                
                // Añadir actividad de login si existe y es diferente al registro
                if (hasLoggedIn && loginDate) {
                    const timeDiff = Math.abs(loginDate - createdDate);
                    // Si el login es más de 1 hora después del registro, contar como actividad separada
                    if (timeDiff > 3600000) {
                        activities.push({
                            date: loginDate,
                            type: 'login',
                            email: user.email,
                            plan: user.user_plan,
                            isActive: user.is_active
                        });
                    }
                }
                
                // Siempre añadir el registro
                activities.push({
                    date: createdDate,
                    type: 'register',
                    email: user.email,
                    plan: user.user_plan,
                    isActive: user.is_active
                });
            });
            
            // Ordenar por fecha descendente
            activities.sort((a, b) => b.date - a.date);
            
            adminRecentActivities = activities;
            adminActivityPage = 1;
            renderAdminActivityPage();
        }
        
    } catch (error) {
        
        if (totalUsersEl) totalUsersEl.textContent = '--';
        if (activeUsersEl) activeUsersEl.textContent = '--';
        if (activeSubsEl) activeSubsEl.textContent = '--';
        if (monthlyRevenueEl) monthlyRevenueEl.textContent = '--';
        if (activityList) activityList.innerHTML = '<p class="error-text">Error al cargar datos</p>';
    }
}

function renderAdminActivityPage() {
    const activityList = document.getElementById('recentActivityList');
    if (!activityList) return;

    const total = adminRecentActivities.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_ACTIVITY_PAGE_SIZE));
    adminActivityPage = Math.min(Math.max(1, adminActivityPage), totalPages);

    const start = (adminActivityPage - 1) * ADMIN_ACTIVITY_PAGE_SIZE;
    const pageItems = adminRecentActivities.slice(start, start + ADMIN_ACTIVITY_PAGE_SIZE);

    activityList.innerHTML = pageItems.map(activity => {
        const timeAgo = getTimeAgo(activity.date);
        let icon = '📝';
        let actionText = 'Registro nuevo';
        let extraInfo = '';

        if (activity.type === 'login') {
            icon = '🔵';
            actionText = 'Login';
        } else if (activity.plan === 'pro') {
            icon = '⬆️';
            actionText = 'Registro PRO';
            extraInfo = '<span class="badge badge-pro" style="font-size: 0.75rem; margin-left: 8px;">PRO</span>';
        } else if (activity.plan === 'unlimited') {
            icon = '⬆️';
            actionText = 'Registro UNLIMITED';
            extraInfo = '<span class="badge badge-unlimited" style="font-size: 0.75rem; margin-left: 8px;">UNLIMITED</span>';
        }

        if (!activity.isActive) {
            icon = '🔒';
            extraInfo += ' <span style="color: #f44336; font-size: 0.75rem;">(Bloqueado)</span>';
        }

        return `
            <div class="activity-item">
                <div class="activity-time">${timeAgo}</div>
                <div class="activity-action">${icon} ${actionText}</div>
                <div class="activity-email">${activity.email} ${extraInfo}</div>
            </div>
        `;
    }).join('') || '<p class="no-data">No hay actividad reciente</p>';

    const section = activityList.parentElement;
    if (!section) return;

    let pagination = document.getElementById('recentActivityPagination');
    if (!pagination) {
        pagination = document.createElement('div');
        pagination.id = 'recentActivityPagination';
        pagination.style.display = 'flex';
        pagination.style.justifyContent = 'space-between';
        pagination.style.alignItems = 'center';
        pagination.style.gap = '8px';
        pagination.style.marginTop = '12px';
        section.appendChild(pagination);
    }

    pagination.innerHTML = `
        <button type="button" id="adminActivityPrev" class="btn-secondary" ${adminActivityPage === 1 ? 'disabled' : ''}>
            ◀ Anterior
        </button>
        <div style="font-size: 0.85rem; color: var(--admin-text-secondary);">
            Página ${adminActivityPage} / ${totalPages}
        </div>
        <button type="button" id="adminActivityNext" class="btn-secondary" ${adminActivityPage === totalPages ? 'disabled' : ''}>
            Siguiente ▶
        </button>
    `;

    const prevBtn = document.getElementById('adminActivityPrev');
    const nextBtn = document.getElementById('adminActivityNext');

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (adminActivityPage > 1) {
                adminActivityPage -= 1;
                renderAdminActivityPage();
            }
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (adminActivityPage < totalPages) {
                adminActivityPage += 1;
                renderAdminActivityPage();
            }
        });
    }
}

function clampPage(page, totalPages) {
    if (totalPages <= 0) return 1;
    return Math.min(Math.max(1, page), totalPages);
}

function ensureAdminPagination(panelId, paginationId) {
    const panel = document.getElementById(panelId);
    if (!panel) return null;

    let pagination = document.getElementById(paginationId);
    if (!pagination) {
        pagination = document.createElement('div');
        pagination.id = paginationId;
        pagination.className = 'admin-pagination';
        panel.appendChild(pagination);
    }
    return pagination;
}

function renderPaginationControls(pagination, page, totalPages, onPrev, onNext) {
    if (!pagination) return;

    if (totalPages <= 1) {
        pagination.innerHTML = '';
        pagination.style.display = 'none';
        return;
    }

    pagination.style.display = 'flex';
    pagination.innerHTML = `
        <button class="btn-secondary btn-small" data-action="prev" ${page <= 1 ? 'disabled' : ''}>← Anterior</button>
        <span class="pagination-info">Página ${page} de ${totalPages}</span>
        <button class="btn-secondary btn-small" data-action="next" ${page >= totalPages ? 'disabled' : ''}>Siguiente →</button>
    `;

    const prevBtn = pagination.querySelector('[data-action="prev"]');
    const nextBtn = pagination.querySelector('[data-action="next"]');

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (page > 1) onPrev();
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (page < totalPages) onNext();
        });
    }
}

function getTimeAgo(date) {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return 'Hace un momento';
    if (seconds < 3600) return `Hace ${Math.floor(seconds / 60)} min`;
    if (seconds < 86400) return `Hace ${Math.floor(seconds / 3600)}h`;
    return `Hace ${Math.floor(seconds / 86400)} días`;
}

// ============================================
// USUARIOS - CRUD completo
// ============================================
async function loadAdminUsers() {
    const tbody = document.getElementById('usersTableBody');
    if (tbody) tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;">Cargando...</td></tr>';
    
    try {
        const result = await adminQuery(`
            SELECT 
                u.id, 
                u.email, 
                u.user_plan, 
                u.is_active, 
                u.created_at, 
                u.expires_at,
                (SELECT COUNT(*) FROM accounts WHERE user_id = u.id AND (is_archived IS NULL OR is_archived = 0)) as accounts_count,
                (SELECT COUNT(*) FROM trades WHERE account_id IN (SELECT id FROM accounts WHERE user_id = u.id)) as trades_count
            FROM users u
            ORDER BY u.created_at DESC 
            LIMIT 100
        `);
        
        adminUsers = (result.rows || []).map(row => {
            // LibSQL can return 0/1, true/false, "0"/"1", or null
            const isActiveValue = row.is_active;
            const isActive = isActiveValue === 1 || isActiveValue === true || isActiveValue === "1";
            
            return {
                id: row.id,
                email: row.email,
                plan: (row.user_plan || 'free').toUpperCase(),
                status: isActive ? '✅ Activo' : '❌ Inactivo',
                created: row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A',
                expires: row.expires_at,
                isActive: isActive,
                accountsCount: row.accounts_count || 0,
                tradesCount: row.trades_count || 0
            };
        });

        adminUsersFiltered = adminUsers.slice();
        adminUsersPage = 1;
        renderUsersPage(adminUsersFiltered);
        
        // Buscador
        const searchInput = document.getElementById('userSearch');
        if (searchInput) {
            searchInput.oninput = (e) => {
                const filtered = adminUsers.filter(u => 
                    u.email.toLowerCase().includes(e.target.value.toLowerCase())
                );
                adminUsersFiltered = filtered;
                adminUsersPage = 1;
                renderUsersPage(adminUsersFiltered);
            };
        }
        
    } catch (error) {
        if (tbody) tbody.innerHTML = '<tr><td colspan="7" class="error-text">Error al cargar usuarios</td></tr>';
    }
}

function renderUsersPage(users) {
    const total = users.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_USERS_PAGE_SIZE));
    adminUsersPage = clampPage(adminUsersPage, totalPages);
    const start = (adminUsersPage - 1) * ADMIN_USERS_PAGE_SIZE;
    const pageItems = users.slice(start, start + ADMIN_USERS_PAGE_SIZE);

    renderUsersTable(pageItems, total);

    const pagination = ensureAdminPagination('usersPanel', 'usersPagination');
    renderPaginationControls(
        pagination,
        adminUsersPage,
        totalPages,
        () => { adminUsersPage -= 1; renderUsersPage(users); },
        () => { adminUsersPage += 1; renderUsersPage(users); }
    );
}

function renderUsersTable(users, totalCount = null) {
    const tbody = document.getElementById('usersTableBody');
    if (!tbody) return;

    const total = totalCount !== null ? totalCount : users.length;
    
    if (total === 0) {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;">No se encontraron usuarios</td></tr>';
        return;
    }
    
    tbody.innerHTML = users.map(user => `
        <tr>
            <td>${user.email}</td>
            <td><span class="badge badge-${user.plan.toLowerCase()}">${user.plan}</span></td>
            <td>${user.status}</td>
            <td style="text-align:center;">${user.accountsCount || 0}</td>
            <td style="text-align:center;">${user.tradesCount || 0}</td>
            <td>${user.created}</td>
            <td>
                <div class="table-actions">
                    <button onclick="adminViewUser('${user.id}')" class="btn-small btn-info">Ver</button>
                    ${user.isActive 
                        ? `<button onclick="adminBlockUser('${user.id}')" class="btn-small btn-danger">Bloquear</button>`
                        : `<button onclick="adminUnblockUser('${user.id}')" class="btn-small btn-success">Desbloquear</button>`
                    }
                </div>
            </td>
        </tr>
    `).join('');
}

// Ver ficha completa del usuario
window.adminViewUser = async function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    try {
        // Cargar datos adicionales del usuario desde la BD incluyendo conteos
        const result = await adminQuery(
            `SELECT 
                u.id, u.email, u.username, u.user_plan, u.is_active, u.created_at, u.expires_at, u.last_login,
                (SELECT COUNT(*) FROM accounts WHERE user_id = u.id AND (is_archived IS NULL OR is_archived = 0)) as accounts_count,
                (SELECT COUNT(*) FROM trades WHERE account_id IN (SELECT id FROM accounts WHERE user_id = u.id)) as trades_count
            FROM users u
            WHERE u.id = ?`,
            [userId]
        );
        
        if (!result.rows || result.rows.length === 0) {
            showAdminNotification('Usuario no encontrado', 'error');
            return;
        }
        
        const userData = result.rows[0];
        const createdDate = userData.created_at ? new Date(userData.created_at).toLocaleString('es-ES') : 'N/A';
        const expiresDate = userData.expires_at ? new Date(userData.expires_at).toLocaleString('es-ES') : 'Sin fecha';
        const lastLoginDate = userData.last_login ? new Date(userData.last_login).toLocaleString('es-ES') : 'Nunca';
        
        const modal = document.createElement('div');
        modal.className = 'admin-action-modal';
        modal.innerHTML = `
            <div class="admin-action-content" style="max-width: 600px;">
                <h3>👤 Ficha de Usuario</h3>
                
                <div class="user-info-grid">
                    <div class="user-info-row">
                        <strong>ID:</strong>
                        <span>${userData.id}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Email:</strong>
                        <span>${userData.email}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Nombre de usuario:</strong>
                        <span>${userData.username || 'No establecido'}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Plan:</strong>
                        <span class="badge badge-${userData.user_plan.toLowerCase()}">${userData.user_plan.toUpperCase()}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Estado:</strong>
                        <span>${userData.is_active ? '✅ Activo' : '❌ Bloqueado'}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Fecha de registro:</strong>
                        <span>${createdDate}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Expira:</strong>
                        <span>${expiresDate}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Último login:</strong>
                        <span>${lastLoginDate}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Cuentas activas:</strong>
                        <span>${userData.accounts_count || 0}</span>
                    </div>
                    <div class="user-info-row">
                        <strong>Trades registrados:</strong>
                        <span>${userData.trades_count || 0}</span>
                    </div>
                </div>
                
                <div class="modal-actions">
                    <button onclick="closeActionModal()" class="btn-primary">Cerrar</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
        
    } catch (error) {
        
        showAdminNotification('Error al cargar datos del usuario', 'error');
    }
};

// Modal para cambiar plan de usuario
window.adminEditUser = function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    // Crear modal
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>Cambiar Plan de Usuario</h3>
            <p><strong>Usuario:</strong> ${user.email}</p>
            <p><strong>Plan actual:</strong> ${user.plan}</p>
            
            <div class="form-group">
                <label>Seleccionar nuevo plan:</label>
                <select id="newPlanSelect" class="admin-select">
                    <option value="free" ${user.plan === 'FREE' ? 'selected' : ''}>FREE - Sin costo, funciones básicas</option>
                    <option value="pro" ${user.plan === 'PRO' ? 'selected' : ''}>PRO - Funciones avanzadas</option>
                    <option value="unlimited" ${user.plan === 'UNLIMITED' ? 'selected' : ''}>UNLIMITED - Todas las funciones</option>
                </select>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmChangePlan('${userId}')" class="btn-primary">Guardar Cambios</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
};

window.confirmChangePlan = async function(userId) {
    const planSelect = document.getElementById('newPlanSelect');
    const durationSelect = document.getElementById('newPlanDurationSelect');
    const newPlan = planSelect.value;
    const days = durationSelect ? parseInt(durationSelect.value) : 30;

    try {
        await adminQuery('UPDATE users SET user_plan = ? WHERE id = ?', [newPlan, userId]);

        if (newPlan === 'pro' || newPlan === 'unlimited') {
            await adminQuery(
                `UPDATE users SET expires_at = datetime('now', '+${days} days') WHERE id = ?`,
                [userId]
            );
            // Desarchivar cuentas si sube de plan
            await adminQuery(
                'UPDATE accounts SET is_archived = 0, archived_at = NULL WHERE user_id = ?',
                [userId]
            );
            showAdminNotification(`Plan actualizado a ${newPlan.toUpperCase()} — ${days} días`);
        } else {
            await adminQuery(
                `UPDATE users SET expires_at = datetime('now', '+1 year') WHERE id = ?`,
                [userId]
            );
            showAdminNotification(`Plan cambiado a FREE`);
        }

        closeActionModal();
        loadAdminUsers();
    } catch (error) {
        showAdminNotification('Error al actualizar plan', 'error');
    }
};

// Bloquear usuario - Impide que pueda hacer login
window.adminBlockUser = function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>⚠️ Bloquear Usuario</h3>
            <p><strong>Usuario:</strong> ${user.email}</p>
            
            <div class="warning-box">
                <p><strong>¿Qué significa bloquear?</strong></p>
                <ul>
                    <li>El usuario NO podrá hacer login</li>
                    <li>Sus datos se mantienen en la base de datos</li>
                    <li>Puedes desbloquearlo en cualquier momento</li>
                    <li>Útil para usuarios con pagos pendientes o comportamiento sospechoso</li>
                </ul>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmBlockUser('${userId}')" class="btn-danger">Sí, Bloquear Usuario</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
};

window.confirmBlockUser = async function(userId) {
    try {
        await adminQuery(
            'UPDATE users SET is_active = ? WHERE id = ?',
            [0, userId]
        );
        showAdminNotification('Usuario bloqueado correctamente');
        closeActionModal();
        // Reload users table to reflect changes
        await loadAdminUsers();
    } catch (error) {
        showAdminNotification('Error al bloquear usuario', 'error');
    }
};

// Desbloquear usuario - Permite que vuelva a hacer login
window.adminUnblockUser = function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>✅ Desbloquear Usuario</h3>
            <p><strong>Usuario:</strong> ${user.email}</p>
            
            <div class="info-box">
                <p><strong>¿Qué significa desbloquear?</strong></p>
                <ul>
                    <li>El usuario PODRÁ hacer login nuevamente</li>
                    <li>Recuperará acceso a su cuenta y datos</li>
                    <li>Su plan y configuración se mantienen</li>
                </ul>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmUnblockUser('${userId}')" class="btn-success">Sí, Desbloquear Usuario</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
};

window.confirmUnblockUser = async function(userId) {
    try {
        await adminQuery(
            'UPDATE users SET is_active = ? WHERE id = ?',
            [1, userId]
        );
        showAdminNotification('Usuario desbloqueado correctamente');
        closeActionModal();
        // Reload users table to reflect changes
        await loadAdminUsers();
    } catch (error) {
        showAdminNotification('Error al desbloquear usuario', 'error');
    }
};

// Cerrar modal de acción
window.closeActionModal = function() {
    const modal = document.querySelector('.admin-action-modal');
    if (modal) modal.remove();
};

// Función legacy para compatibilidad
window.adminToggleUser = async function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    if (user.isActive) {
        adminBlockUser(userId);
    } else {
        adminUnblockUser(userId);
    }
};

window.adminRefreshUsers = function() {
    loadAdminUsers();
    showAdminNotification('✅ Lista actualizada');
};

// ============================================
// SUSCRIPCIONES
// ============================================
async function loadAdminSubscriptions() {
    const tbody = document.getElementById('subsTableBody');
    if (tbody) tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;">Cargando...</td></tr>';
    
    try {
        const result = await adminQuery(`
            SELECT id, email, user_plan, created_at, expires_at, is_active 
            FROM users 
            ORDER BY expires_at ASC 
            LIMIT 100
        `);
        
        adminSubs = (result.rows || []).map(row => {
            const expires = row.expires_at ? new Date(row.expires_at) : null;
            const createdAt = row.created_at ? new Date(row.created_at) : null;
            const now = new Date();
            let status = '✅ Activa';
            if (!expires) status = '⏳ Sin fecha';
            else if (expires < now) status = '❌ Expirada';
            else if (expires - now < 7 * 24 * 60 * 60 * 1000) status = '⚠️ Por vencer';
            
            return {
                id: row.id,
                email: row.email,
                plan: (row.user_plan || 'free').toUpperCase(),
                planKey: (row.user_plan || 'free').toLowerCase(),
                start: createdAt ? createdAt.toLocaleDateString() : 'N/A',
                startDate: createdAt,
                expires: expires ? expires.toLocaleDateString() : 'N/A',
                status: status
            };
        });

        adminSubsFiltered = adminSubs.slice();
        adminSubsPage = 1;
        if (typeof window.filterAdminSubscriptions === 'function') {
            window.filterAdminSubscriptions();
        } else {
            renderSubsPage(adminSubsFiltered);
        }
        
    } catch (error) {
        
        if (tbody) tbody.innerHTML = '<tr><td colspan="6" class="error-text">Error al cargar suscripciones</td></tr>';
    }
}

function renderSubsPage(subs) {
    const total = subs.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_SUBS_PAGE_SIZE));
    adminSubsPage = clampPage(adminSubsPage, totalPages);
    const start = (adminSubsPage - 1) * ADMIN_SUBS_PAGE_SIZE;
    const pageItems = subs.slice(start, start + ADMIN_SUBS_PAGE_SIZE);

    renderSubsTable(pageItems, total);

    const pagination = ensureAdminPagination('subscriptionsPanel', 'subsPagination');
    renderPaginationControls(
        pagination,
        adminSubsPage,
        totalPages,
        () => { adminSubsPage -= 1; renderSubsPage(subs); },
        () => { adminSubsPage += 1; renderSubsPage(subs); }
    );
}

function renderSubsTable(subs, totalCount = null) {
    const tbody = document.getElementById('subsTableBody');
    if (!tbody) return;

    const total = totalCount !== null ? totalCount : subs.length;
    
    if (total === 0) {
        tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;">No hay suscripciones</td></tr>';
        return;
    }
    
    tbody.innerHTML = subs.map(sub => `
        <tr>
            <td>${sub.email}</td>
            <td><span class="badge badge-${sub.plan.toLowerCase()}">${sub.plan}</span></td>
            <td>${sub.start}</td>
            <td>${sub.expires}</td>
            <td>${sub.status}</td>
            <td>
                <div class="table-actions">
                    ${sub.plan === 'FREE' 
                        ? `<button onclick="adminChangePlanSub('${sub.id}')" class="btn-small btn-success">Cambiar a Pago</button>`
                        : `<button onclick="adminRenewSub('${sub.id}')" class="btn-small btn-success">Renovar</button>
                           <button onclick="adminChangePlanSub('${sub.id}')" class="btn-small btn-info">Cambiar Plan</button>`
                    }
                </div>
            </td>
        </tr>
    `).join('');
}

// Filtros de suscripciones (plan + fecha de inicio + búsqueda)
window.filterAdminSubscriptions = function() {
    const planFilter = (document.getElementById('subsPlanFilter')?.value || '').toLowerCase();
    const searchValue = (document.getElementById('subsSearch')?.value || '').toLowerCase().trim();
    const startFromValue = document.getElementById('subsStartFrom')?.value || '';
    const startToValue = document.getElementById('subsStartTo')?.value || '';

    const fromDate = startFromValue ? new Date(`${startFromValue}T00:00:00`) : null;
    const toDate = startToValue ? new Date(`${startToValue}T23:59:59`) : null;

    adminSubsFiltered = adminSubs.filter(sub => {
        if (planFilter && sub.planKey !== planFilter) return false;
        if (searchValue && !(sub.email || '').toLowerCase().includes(searchValue)) return false;

        if ((fromDate || toDate)) {
            if (!sub.startDate) return false;
            const start = sub.startDate;
            if (fromDate && start < fromDate) return false;
            if (toDate && start > toDate) return false;
        }

        return true;
    });

    adminSubsPage = 1;
    renderSubsPage(adminSubsFiltered);
};

// Modal para renovar suscripción
window.adminRenewSub = function(subId) {
    const sub = adminSubs.find(s => s.id === subId);
    if (!sub) return;
    
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>Renovar Suscripción</h3>
            <p><strong>Usuario:</strong> ${sub.email}</p>
            <p><strong>Plan:</strong> ${sub.plan}</p>
            <p><strong>Expira:</strong> ${sub.expires}</p>
            
            <div class="form-group">
                <label>Días a añadir:</label>
                <select id="renewDaysSelect" class="admin-select">
                    <option value="7">7 días (1 semana)</option>
                    <option value="30" selected>30 días (1 mes)</option>
                    <option value="90">90 días (3 meses)</option>
                    <option value="180">180 días (6 meses)</option>
                    <option value="365">365 días (1 año)</option>
                </select>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmRenewSub('${subId}')" class="btn-primary">Renovar Suscripción</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
};

window.confirmRenewSub = async function(subId) {
    const select = document.getElementById('renewDaysSelect');
    const days = parseInt(select.value);
    
    try {
        await adminQuery(
            `UPDATE users SET expires_at = datetime(COALESCE(expires_at, 'now'), '+${days} days') WHERE id = ?`,
            [subId]
        );
        showAdminNotification(`Suscripción renovada +${days} días`);
        closeActionModal();
        loadAdminSubscriptions();
    } catch (error) {
        showAdminNotification('Error al renovar', 'error');
    }
};

window.adminChangePlanSub = function(subId) {
    const sub = adminSubs.find(s => s.id === subId);
    if (!sub) return;
    
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>Cambiar Plan</h3>
            <p><strong>Usuario:</strong> ${sub.email}</p>
            <p><strong>Plan actual:</strong> ${sub.plan}</p>
            
            <div class="form-group">
                <label>Nuevo plan:</label>
                <select id="newSubPlanSelect" class="admin-select">
                    <option value="free" ${sub.plan === 'FREE' ? 'selected' : ''}>FREE - Sin costo</option>
                    <option value="pro" ${sub.plan === 'PRO' ? 'selected' : ''}>PRO - Funciones avanzadas</option>
                    <option value="unlimited" ${sub.plan === 'UNLIMITED' ? 'selected' : ''}>UNLIMITED - Sin límites</option>
                </select>
            </div>

            <div class="form-group" id="durationGroup">
                <label>Duración:</label>
                <select id="newSubDurationSelect" class="admin-select">
                    <option value="1">1 día (prueba)</option>
                    <option value="7">7 días (1 semana)</option>
                    <option value="30" selected>30 días (1 mes)</option>
                    <option value="90">90 días (3 meses)</option>
                    <option value="180">180 días (6 meses)</option>
                    <option value="365">365 días (1 año)</option>
                </select>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmChangePlanSub('${subId}')" class="btn-primary">Cambiar Plan</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);

    // Ocultar duración si selecciona FREE
    document.getElementById('newSubPlanSelect').addEventListener('change', function() {
        const durationGroup = document.getElementById('durationGroup');
        if (this.value === 'free') {
            durationGroup.style.display = 'none';
        } else {
            durationGroup.style.display = 'block';
        }
    });
};

window.confirmChangePlanSub = async function(subId) {
    const planSelect = document.getElementById('newSubPlanSelect');
    const durationSelect = document.getElementById('newSubDurationSelect');
    const newPlan = planSelect.value;
    const days = durationSelect ? parseInt(durationSelect.value) : 30;
    
    try {
        if (newPlan === 'free') {
            await adminQuery(
                `UPDATE users SET user_plan = ?, expires_at = datetime('now', '+1 year') WHERE id = ?`,
                [newPlan, subId]
            );
            showAdminNotification(`Plan cambiado a FREE`);
        } else {
            await adminQuery(
                `UPDATE users SET user_plan = ?, expires_at = datetime('now', '+${days} days') WHERE id = ?`,
                [newPlan, subId]
            );
            showAdminNotification(`Plan cambiado a ${newPlan.toUpperCase()} — ${days} días`);
        }
        closeActionModal();
        loadAdminSubscriptions();
    } catch (error) {
        showAdminNotification('Error al cambiar plan', 'error');
    }
};
window.adminRefreshSubs = function() {
    loadAdminSubscriptions();
    showAdminNotification('✅ Suscripciones actualizadas');
};

// ============================================
// CUENTAS ARCHIVADAS
// ============================================
async function loadAdminArchivedAccounts() {
    const tbody = document.getElementById('archivedAccountsTableBody');
    if (tbody) tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;">Cargando...</td></tr>';

    try {
        const result = await adminQuery(`
            SELECT id, user_id, name, status, balance, archived_at, created_at
            FROM accounts
            WHERE is_archived = 1
            ORDER BY archived_at DESC
            LIMIT 200
        `);

        adminArchivedAccounts = result.rows || [];
        adminArchivedPage = 1;
        renderArchivedAccountsPage(adminArchivedAccounts);
    } catch (error) {
        if (tbody) tbody.innerHTML = '<tr><td colspan="6" class="error-text">Error al cargar cuentas archivadas</td></tr>';
    }
}

window.adminRefreshArchivedAccounts = function() {
    loadAdminArchivedAccounts();
    showAdminNotification('✅ Lista actualizada');
};

function renderArchivedAccountsPage(accounts) {
    const total = accounts.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_ARCHIVED_PAGE_SIZE));
    adminArchivedPage = clampPage(adminArchivedPage, totalPages);
    const start = (adminArchivedPage - 1) * ADMIN_ARCHIVED_PAGE_SIZE;
    const pageItems = accounts.slice(start, start + ADMIN_ARCHIVED_PAGE_SIZE);

    renderArchivedAccountsTable(pageItems, total);

    const pagination = ensureAdminPagination('archivedPanel', 'archivedPagination');
    renderPaginationControls(
        pagination,
        adminArchivedPage,
        totalPages,
        () => { adminArchivedPage -= 1; renderArchivedAccountsPage(accounts); },
        () => { adminArchivedPage += 1; renderArchivedAccountsPage(accounts); }
    );
}

function renderArchivedAccountsTable(accounts, totalCount = null) {
    const tbody = document.getElementById('archivedAccountsTableBody');
    if (!tbody) return;

    const total = totalCount !== null ? totalCount : accounts.length;
    if (total === 0) {
        tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;">No hay cuentas archivadas</td></tr>';
        return;
    }

    tbody.innerHTML = accounts.map(acc => {
        const archivedAt = acc.archived_at ? formatDateTime(acc.archived_at) : 'N/A';
        const createdAt = acc.created_at ? formatDateTime(acc.created_at) : 'N/A';
        const balance = acc.balance !== null && acc.balance !== undefined ? Number(acc.balance).toFixed(2) : '0.00';
        return `
            <tr>
                <td>${escapeHtml(acc.name || 'N/A')}</td>
                <td>${escapeHtml(acc.status || 'N/A')}</td>
                <td>${balance}</td>
                <td>${escapeHtml(acc.user_id || 'N/A')}</td>
                <td>${createdAt}</td>
                <td>${archivedAt}</td>
            </tr>
        `;
    }).join('');
}

window.adminCleanupArchivedAccounts = async function() {
    const token = window._adminToken;
    if (!token) {
        if (window.showAlert) window.showAlert('No hay sesión de admin activa', 'error');
        return;
    }

    const confirmed = window.showConfirm
        ? await window.showConfirm({
            title: 'Limpiar cuentas archivadas',
            message: 'Se eliminarán cuentas archivadas con sus trades. ¿Continuar?',
            confirmText: 'Limpiar',
            cancelText: 'Cancelar',
            type: 'warning'
        })
        : confirm('Se eliminarán cuentas archivadas con sus trades. ¿Continuar?');

    if (!confirmed) return;

    try {
        const response = await fetch(`${getAdminWorkerUrl()}/api/admin/cleanup-archived-accounts`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.success) {
            throw new Error(data.error || 'No se pudo limpiar');
        }

        showAdminNotification('🧹 Limpieza completada');
        loadAdminArchivedAccounts();
    } catch (error) {
        showAdminNotification('Error al limpiar cuentas archivadas', 'error');
    }
};

/* 
// ============================================
// SINCRONIZACIÓN MT4/MT5 (DESHABILITADA)
// ============================================
async function loadAdminSyncStatus() {
    // Función deshabilitada - pestaña MT4/MT5 eliminada
}

window.saveAdminSyncConfig = function(event) {
    // Función deshabilitada - pestaña MT4/MT5 eliminada
};
*/

// ============================================
// LOGS / AUDITORÍA - Actividad reciente
// ============================================
async function loadAdminLogs() {
    const logsList = document.getElementById('logsList');
    if (!logsList) return;
    
    logsList.innerHTML = '<p style="text-align:center;padding:20px;">Cargando logs de auditoría...</p>';
    
    try {
        // ============================================
        // 1️⃣ CARGAR LOGS DE AUDITOR?A (tabla nueva y completa)
        // ============================================
        let auditLogs = [];
        try {
            const auditResult = await adminQuery(`
                SELECT 
                    al.id,
                    al.user_id,
                    u.email,
                    al.action,
                    al.resource_type,
                    al.details,
                    al.status,
                    al.ip_address,
                    al.created_at
                FROM audit_logs al
                LEFT JOIN users u ON al.user_id = u.id
                ORDER BY al.created_at DESC
                LIMIT 200
            `);
            auditLogs = (auditResult.rows || []).map(row => ({
                timestamp: row.created_at,
                user: row.email || row.user_id || 'Sistema',
                action: row.action,
                resource: row.resource_type,
                details: row.details ? JSON.parse(row.details) : {},
                status: row.status,
                ip: row.ip_address || 'N/A',
                type: 'audit'
            }));
        } catch (auditError) {
            warn('⚠️ Tabla audit_logs no existe o está vacía:', auditError.message);
        }
        
        // ============================================
        // 2️⃣ CARGAR CAMBIOS DE CONTRASE?A (legacy)
        // ============================================
        let passwordLogs = [];
        try {
            const passwordResult = await adminQuery(`
                SELECT 
                    pcl.id,
                    pcl.user_id,
                    u.email,
                    pcl.changed_at,
                    pcl.reason,
                    pcl.ip_address,
                    pcl.changed_by
                FROM password_change_logs pcl
                LEFT JOIN users u ON pcl.user_id = u.id
                ORDER BY pcl.changed_at DESC
                LIMIT 100
            `);
            passwordLogs = (passwordResult.rows || []).map(row => ({
                timestamp: row.changed_at,
                user: row.email || 'Desconocido',
                action: row.changed_by === 'self' ? 'Usuario: Cambió Contraseña' : 'Admin: Reset Contraseña',
                details: row.reason || 'Cambio de contraseña',
                status: 'success',
                ip: row.ip_address || 'N/A',
                type: 'password_change'
            }));
        } catch (e) {
            warn('⚠️ Tabla password_change_logs no existe:', e.message);
        }
        
        // ============================================
        // 3️⃣ CARGAR LOGINS DE USUARIOS (legacy)
        // ============================================
        let loginLogs = [];
        try {
            const loginResult = await adminQuery(`
                SELECT email, created_at, user_plan, is_active, last_login 
                FROM users 
                ORDER BY COALESCE(last_login, created_at) DESC 
                LIMIT 100
            `);
            
            loginLogs = (loginResult.rows || []).flatMap(row => {
                const logs = [];
                const lastLoginDate = row.last_login ? new Date(row.last_login) : null;
                const createdDate = row.created_at ? new Date(row.created_at) : null;

                // Log de registro
                if (createdDate) {
                    logs.push({
                        timestamp: row.created_at,
                        user: row.email,
                        action: 'Usuario Registrado',
                        details: `Plan: ${(row.user_plan || 'free').toUpperCase()}`,
                        status: 'success',
                        type: 'user_created'
                    });
                }

                // Log de último login
                if (lastLoginDate) {
                    logs.push({
                        timestamp: row.last_login,
                        user: row.email,
                        action: 'Login',
                        details: `Plan: ${(row.user_plan || 'free').toUpperCase()} | Activo: ${row.is_active ? 'Sí' : 'No'}`,
                        status: 'success',
                        type: 'login'
                    });
                }

                return logs;
            });
        } catch (loginError) {
            warn('⚠️ Error cargando logins:', loginError.message);
        }
        
        // ============================================
        // 4️⃣ COMBINAR Y ORDENAR TODOS LOS LOGS
        // ============================================
        adminLogs = [...auditLogs, ...passwordLogs, ...loginLogs].sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp);
        });

        adminLogsFiltered = adminLogs.slice();
        adminLogsPage = 1;
        renderLogsPage(adminLogsFiltered);
        
    } catch (error) {
        logsList.innerHTML = '<p class="error-text">Error cargando auditoría: ' + error.message + '</p>';
    }
}

function renderLogsPage(logs) {
    const total = logs.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_LOGS_PAGE_SIZE));
    adminLogsPage = clampPage(adminLogsPage, totalPages);
    const start = (adminLogsPage - 1) * ADMIN_LOGS_PAGE_SIZE;
    const pageItems = logs.slice(start, start + ADMIN_LOGS_PAGE_SIZE);

    renderLogs(pageItems, total);

    const pagination = ensureAdminPagination('logsPanel', 'logsPagination');
    renderPaginationControls(
        pagination,
        adminLogsPage,
        totalPages,
        () => { adminLogsPage -= 1; renderLogsPage(logs); },
        () => { adminLogsPage += 1; renderLogsPage(logs); }
    );
}

function renderLogs(logs, totalCount = null) {
    const logsList = document.getElementById('logsList');
    if (!logsList) return;

    const total = totalCount !== null ? totalCount : logs.length;
    
    if (total === 0) {
        logsList.innerHTML = '<p class="no-data" style="text-align:center;padding:20px;color:#90a4ae;">📋 No hay registros de auditoría</p>';
        return;
    }
    
    logsList.innerHTML = logs.map(log => {
        // Determinar clase según tipo de log
        let actionClass = 'log-action-default';
        let icon = '📋';
        let displayAction = log.action;
        let displayDetails = log.details;

        if (log.type === 'password_changed') {
            actionClass = 'log-action-password';
            icon = '🔐';
            displayAction = `${icon} ${log.action}`;
        } else if (log.type === 'login') {
            actionClass = 'log-action-login';
            icon = '🔓';
            displayAction = `${icon} ${log.action}`;
        } else if (log.type === 'user_created') {
            actionClass = 'log-action-register';
            icon = '👤';
            displayAction = `${icon} ${log.action}`;
        } else if (log.type === 'audit') {
            // Logs de auditoría personalizados
            const action = log.action || '';
            
            if (action.includes('PLAN_PURCHASE')) {
                icon = '💳';
                actionClass = 'log-action-success';
                const details = log.details || {};
                displayAction = `${icon} Compra de Plan`;
                displayDetails = `${details.previousPlan || 'free'} → ${details.newPlan} | Vence: ${details.expiresAt ? new Date(details.expiresAt).toLocaleDateString('es-ES') : 'N/A'}`;
            } else if (action.includes('PLAN_CANCELLED')) {
                icon = '❌';
                actionClass = 'log-action-error';
                const details = log.details || {};
                displayAction = `${icon} Cancelación de Plan`;
                displayDetails = `${details.previousPlan} → free`;
            } else if (action.includes('PLAN_SUSPENDED')) {
                icon = '⏸️';
                actionClass = 'log-action-warning';
                displayAction = `${icon} Plan Suspendido`;
            } else if (action.includes('PLAN_EXPIRED')) {
                icon = '⏰';
                actionClass = 'log-action-warning';
                displayAction = `${icon} Plan Expirado`;
            } else if (action.includes('LOGIN')) {
                icon = '🔓';
                actionClass = 'log-action-login';
                displayAction = `${icon} Login`;
            } else {
                displayAction = `📌 ${action}`;
            }
            
            // Agregar IP si existe
            if (log.ip && log.ip !== 'N/A') {
                displayDetails += ` | IP: ${log.ip}`;
            }
        } else {
            displayAction = `📌 ${log.action}`;
        }

        return `
            <div class="log-entry" style="border-left: 4px solid ${
                log.type === 'audit' && log.action.includes('PURCHASE') ? '#4caf50' :
                log.type === 'audit' && log.action.includes('CANCEL') ? '#f44336' :
                log.type === 'password_changed' ? '#2196f3' :
                log.type === 'login' ? '#ff9800' :
                '#9e9e9e'
            };">
                <div class="log-timestamp">${log.timestamp ? new Date(log.timestamp).toLocaleString('es-ES') : 'N/A'}</div>
                <div class="log-user"><strong>${log.user}</strong></div>
                <div class="log-action ${actionClass}" style="font-weight: 500;">${displayAction}</div>
                <div class="log-details">${typeof displayDetails === 'string' ? displayDetails : JSON.stringify(displayDetails)}</div>
                <div style="font-size: 12px; color: #757575; margin-top: 5px;">
                    Estado: <span style="color: ${log.status === 'success' ? '#4caf50' : '#f44336'}">${log.status || 'success'}</span>
                </div>
            </div>
        `;
    }).join('');
}

window.filterAdminLogs = function() {
    if (!adminLogs || adminLogs.length === 0) {
        loadAdminLogs();
        return;
    }
    const typeFilter = document.getElementById('logFilter')?.value || '';
    const textQuery = (document.getElementById('logSearch')?.value || '').trim().toLowerCase();

    let filtered = adminLogs.slice();

    if (typeFilter) {
        const normalized = typeFilter.toLowerCase();
        filtered = filtered.filter(log => {
            if (normalized === 'password_changed') return log.type === 'password_changed';
            if (normalized === 'login') return log.type === 'login' || String(log.action || '').toLowerCase().includes('login');
            if (normalized === 'user_created') return log.type === 'user_created' || String(log.action || '').toLowerCase().includes('usuario creado') || String(log.action || '').toLowerCase().includes('registro');

            const haystack = [
                log.user,
                log.action,
                log.details,
                log.ip,
                log.timestamp,
                log.lastLogin,
                log.created
            ].filter(Boolean).join(' ').toLowerCase();

            return haystack.includes(normalized);
        });
    }

    if (textQuery) {
        filtered = filtered.filter(log => {
            const haystack = [
                log.user,
                log.action,
                log.details,
                log.ip,
                log.timestamp,
                log.lastLogin,
                log.created
            ].filter(Boolean).join(' ').toLowerCase();

            return haystack.includes(textQuery);
        });
    }

    adminLogsFiltered = filtered;
    adminLogsPage = 1;
    renderLogsPage(adminLogsFiltered);
};

window.adminExportLogs = function() {
    const csv = 'Timestamp,Usuario,Acción,Detalles\n' + 
        adminLogs.map(log => `"${log.timestamp}","${log.user}","${log.action}","${log.details}"`).join('\n');
    
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `admin-logs-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    showAdminNotification('📥 Logs exportados');
};

// ============================================
// CONFIGURACIÓN
// ============================================
window.saveAdminSecurity = async function(event) {
    event.preventDefault();
    const current = document.getElementById('currentPassword')?.value;
    const newPass = document.getElementById('newPassword')?.value;
    const confirm = document.getElementById('confirmPassword')?.value;
    
    if (newPass !== confirm) {
        showAdminNotification('❌ Las contraseñas no coinciden', 'error');
        return;
    }
    
    if (newPass.length < 8) {
        showAdminNotification('❌ Mínimo 8 caracteres', 'error');
        return;
    }
    
    // TODO: Implementar cambio de contraseña via worker
    showAdminNotification('✅ Contraseña actualizada');
    document.getElementById('securityForm')?.reset();
};

window.saveAdminSystemConfig = function(event) {
    event.preventDefault();
    const maintenance = document.getElementById('maintenanceMode')?.checked;
    const debug = document.getElementById('debugMode')?.checked;
    const maxAttempts = document.getElementById('maxLoginAttempts')?.value;
    
    localStorage.setItem('adminSystemConfig', JSON.stringify({
        maintenanceMode: maintenance,
        debugMode: debug,
        maxLoginAttempts: maxAttempts
    }));
    
    showAdminNotification('✅ Configuración guardada');
};

// ============================================
// DISCOUNT CODES MANAGEMENT
// ============================================

async function loadAdminDiscounts() {
    const tbody = document.getElementById('discountsTableBody');
    if (!tbody) return;
    
    try {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;">Cargando descuentos...</td></tr>';
        
        const adminToken = window._adminToken;
        if (!adminToken) {
            tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;color:#f44336;">No hay sesión activa</td></tr>';
            return;
        }
        
        const response = await fetch(`${getAdminWorkerUrl()}/api/admin/list-discount-codes`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        
        const data = await response.json();
        adminDiscounts = data.codes || [];
        adminDiscountsFiltered = [...adminDiscounts];
        adminDiscountsPage = 1;
        renderAdminDiscountsPage();
        
    } catch (error) {
        console.error('Error loading discounts:', error);
        tbody.innerHTML = `<tr><td colspan="7" style="text-align:center;padding:20px;color:#f44336;">Error: ${error.message}</td></tr>`;
    }
}

function renderAdminDiscountsPage() {
    const start = (adminDiscountsPage - 1) * ADMIN_DISCOUNTS_PAGE_SIZE;
    const end = start + ADMIN_DISCOUNTS_PAGE_SIZE;
    const pageData = adminDiscountsFiltered.slice(start, end);
    
    renderAdminDiscountsTable(pageData);
    renderDiscountsPagination();
}

function renderAdminDiscountsTable(discounts) {
    const tbody = document.getElementById('discountsTableBody');
    if (!tbody) return;
    
    if (!discounts || discounts.length === 0) {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;">No hay descuentos registrados</td></tr>';
        return;
    }
    
    tbody.innerHTML = discounts.map(code => {
        const isExpired = code.expiration_date && new Date(code.expiration_date) < new Date();
        const status = !code.is_active ? '❌ Inactivo' : isExpired ? '⏰ Expirado' : '✅ Activo';
        const statusColor = !code.is_active ? '#f44336' : isExpired ? '#ff9800' : '#4caf50';
        const expiresAt = code.expiration_date ? formatDate(code.expiration_date) : 'Sin límite';
        const usesInfo = `${code.uses_count || 0}/${code.max_uses || '∞'}`;
        
        return `
            <tr>
                <td><code style="background:var(--bg-0);padding:4px 8px;border-radius:4px;font-size:0.85em;">${escapeHtml(code.code)}</code></td>
                <td>${escapeHtml(code.plan_name || 'N/A')}</td>
                <td><strong>${code.discount_percentage}%</strong></td>
                <td><small>${usesInfo}</small></td>
                <td><small>${expiresAt}</small></td>
                <td><span style="color:${statusColor};">${status}</span></td>
                <td style="white-space:nowrap;">
                    <button onclick="adminToggleDiscount('${code.id}')" class="btn-small" title="Activar/Desactivar" style="margin-right:4px;">
                        ${code.is_active ? '🔒' : '🔓'}
                    </button>
                    <button onclick="adminDeleteDiscount('${code.id}')" class="btn-small" style="color:#f44336;" title="Eliminar">
                        🗑️
                    </button>
                </td>
            </tr>
        `;
    }).join('');
}

function renderDiscountsPagination() {
    const container = document.getElementById('discountsPagination');
    if (!container) return;
    
    const totalPages = Math.ceil(adminDiscountsFiltered.length / ADMIN_DISCOUNTS_PAGE_SIZE);
    if (totalPages <= 1) {
        container.innerHTML = '';
        return;
    }
    
    let html = '<div style="display:flex;gap:8px;justify-content:center;padding:16px;">';
    
    if (adminDiscountsPage > 1) {
        html += `<button onclick="adminDiscountsPage--;renderAdminDiscountsPage()" class="btn-secondary">← Anterior</button>`;
    }
    
    html += `<span style="padding:8px 12px;color:#90a4ae;">Página ${adminDiscountsPage} de ${totalPages}</span>`;
    
    if (adminDiscountsPage < totalPages) {
        html += `<button onclick="adminDiscountsPage++;renderAdminDiscountsPage()" class="btn-secondary">Siguiente →</button>`;
    }
    
    html += '</div>';
    container.innerHTML = html;
}

function filterAdminDiscounts() {
    const search = (document.getElementById('discountSearch')?.value || '').toLowerCase();
    const planFilter = document.getElementById('discountPlanFilter')?.value || '';
    
    adminDiscountsFiltered = adminDiscounts.filter(code => {
        const matchSearch = !search || code.code.toLowerCase().includes(search);
        const matchPlan = !planFilter || code.plan_name === planFilter;
        return matchSearch && matchPlan;
    });
    
    adminDiscountsPage = 1;
    renderAdminDiscountsPage();
}

function openAdminDiscountForm() {
    const modal = document.createElement('div');
    modal.id = 'discountFormModal';
    modal.style.cssText = `
        position:fixed;top:0;left:0;width:100%;height:100%;
        background:rgba(0,0,0,0.7);z-index:10002;display:flex;
        align-items:center;justify-content:center;
    `;
    
    modal.innerHTML = `
        <div style="
            background:var(--bg-1);border-radius:12px;padding:24px;
            max-width:500px;width:90%;box-shadow:0 8px 24px rgba(0,0,0,0.3);
        ">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
                <h3 style="margin:0;">Crear Nuevo Descuento</h3>
                <button onclick="document.getElementById('discountFormModal').remove()" 
                    style="background:transparent;border:none;color:#fff;font-size:24px;cursor:pointer;">✕</button>
            </div>
            
            <form id="discountForm" onsubmit="adminCreateDiscount(event)">
                <div style="margin-bottom:16px;">
                    <label style="display:block;margin-bottom:8px;color:#90a4ae;font-size:0.9em;">Código</label>
                    <input type="text" id="discountCode" required placeholder="TFX_PROMO_2024" 
                        style="width:100%;padding:10px;background:var(--bg-0);border:1px solid rgba(255,255,255,0.1);
                        border-radius:8px;color:#fff;box-sizing:border-box;">
                </div>
                
                <div style="margin-bottom:16px;">
                    <label style="display:block;margin-bottom:8px;color:#90a4ae;font-size:0.9em;">Plan</label>
                    <select id="discountPlan" required 
                        style="width:100%;padding:10px;background:var(--bg-0);border:1px solid rgba(255,255,255,0.1);
                        border-radius:8px;color:#fff;box-sizing:border-box;">
                        <option value="">Selecciona un plan</option>
                        <option value="pro">Pro</option>
                        <option value="unlimited">Unlimited</option>
                        <option value="free">Free</option>
                    </select>
                </div>
                
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;">
                    <div>
                        <label style="display:block;margin-bottom:8px;color:#90a4ae;font-size:0.9em;">Descuento %</label>
                        <input type="number" id="discountPercent" required min="0" max="100" value="50"
                            style="width:100%;padding:10px;background:var(--bg-0);border:1px solid rgba(255,255,255,0.1);
                            border-radius:8px;color:#fff;box-sizing:border-box;">
                    </div>
                    <div>
                        <label style="display:block;margin-bottom:8px;color:#90a4ae;font-size:0.9em;">Máx. Usos</label>
                        <input type="number" id="discountMaxUses" required min="1" value="1"
                            style="width:100%;padding:10px;background:var(--bg-0);border:1px solid rgba(255,255,255,0.1);
                            border-radius:8px;color:#fff;box-sizing:border-box;">
                    </div>
                </div>
                
                <div style="margin-bottom:20px;">
                    <label style="display:block;margin-bottom:8px;color:#90a4ae;font-size:0.9em;">Expira (opcional)</label>
                    <input type="date" id="discountExpires" 
                        style="width:100%;padding:10px;background:var(--bg-0);border:1px solid rgba(255,255,255,0.1);
                        border-radius:8px;color:#fff;box-sizing:border-box;">
                </div>
                
                <div style="display:flex;gap:8px;justify-content:flex-end;">
                    <button type="button" onclick="document.getElementById('discountFormModal').remove()" 
                        class="btn-secondary">Cancelar</button>
                    <button type="submit" class="btn-primary">Crear Descuento</button>
                </div>
            </form>
        </div>
    `;
    
    document.body.appendChild(modal);
}

async function adminCreateDiscount(event) {
    event.preventDefault();
    
    const code = (document.getElementById('discountCode')?.value || '').toUpperCase().trim();
    const plan = document.getElementById('discountPlan')?.value;
    const percent = parseInt(document.getElementById('discountPercent')?.value || '0');
    const maxUses = parseInt(document.getElementById('discountMaxUses')?.value || '1');
    const expires = document.getElementById('discountExpires')?.value || null;
    
    if (!code || !plan || percent < 0 || percent > 100 || maxUses < 1) {
        if (window.showAlert) window.showAlert('Completa todos los campos correctamente', 'error');
        return;
    }
    
    try {
        const adminToken = window._adminToken;
        if (!adminToken) {
            if (window.showAlert) window.showAlert('No hay sesión de admin', 'error');
            return;
        }
        
        const response = await fetch(`${getAdminWorkerUrl()}/api/admin/discount-codes`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code,
                planName: plan,
                discountPercentage: percent,
                maxUses,
                expirationDate: expires
            })
        });
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || `HTTP ${response.status}`);
        }
        
        document.getElementById('discountFormModal').remove();
        showAdminNotification(`✅ Descuento "${code}" creado exitosamente`);
        await loadAdminDiscounts();
        
    } catch (error) {
        console.error('Error creating discount:', error);
        if (window.showAlert) window.showAlert(`Error: ${error.message}`, 'error');
    }
}

async function adminToggleDiscount(discountId) {
    const discount = adminDiscounts.find(d => d.id === discountId);
    if (!discount) return;
    
    try {
        const adminToken = window._adminToken;
        if (!adminToken) {
            if (window.showAlert) window.showAlert('No hay sesión de admin', 'error');
            return;
        }
        
        const newStatus = !discount.is_active;
        const response = await fetch(`${getAdminWorkerUrl()}/api/admin/discount-codes/${discountId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ is_active: newStatus })
        });
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        
        showAdminNotification(newStatus ? '✅ Descuento activado' : '✅ Descuento desactivado');
        await loadAdminDiscounts();
        
    } catch (error) {
        console.error('Error toggling discount:', error);
        if (window.showAlert) window.showAlert(`Error: ${error.message}`, 'error');
    }
}

async function adminDeleteDiscount(discountId) {
    const discount = adminDiscounts.find(d => d.id === discountId);
    if (!discount) return;
    
    const confirmed = window.showConfirm
        ? await window.showConfirm({
            title: 'Eliminar descuento',
            message: `¿Eliminar descuento "${discount.code}"?`,
            confirmText: 'Eliminar',
            cancelText: 'Cancelar',
            type: 'warning'
        })
        : confirm(`¿Eliminar descuento "${discount.code}"?`);
    
    if (!confirmed) return;
    
    try {
        const adminToken = window._adminToken;
        if (!adminToken) {
            if (window.showAlert) window.showAlert('No hay sesión de admin', 'error');
            return;
        }
        
        const response = await fetch(`${getAdminWorkerUrl()}/api/admin/discount-codes/${discountId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        
        showAdminNotification('✅ Descuento eliminado');
        await loadAdminDiscounts();
        
    } catch (error) {
        console.error('Error deleting discount:', error);
        if (window.showAlert) window.showAlert(`Error: ${error.message}`, 'error');
    }
}

// Helper para formatear fechas
function formatDate(dateString) {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
        return dateString;
    }
}

/**
 * Notificación toast
 */
function showAdminNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `admin-notification admin-notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 12px 20px;
        border-radius: 8px;
        background: ${type === 'error' ? '#d32f2f' : type === 'warning' ? '#f57c00' : '#388e3c'};
        color: white;
        z-index: 100001;
        animation: slideIn 0.3s ease;
        font-weight: 500;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => notification.remove(), 300);
    }, 3000);
}

// Inicializar panel cuando se abre
window.initAdminPanel = function() {
    switchAdminTab('dashboard');
    setTimeout(() => {
        makeAdminWindowDraggable();
        startAdminSession();
    }, 100);
};

// Auto-restaurar sesión al cargar página (solo si estaba minimizado)
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        if (window.checkAdminSession && window.checkAdminSession()) {
            const wasMinimized = sessionStorage.getItem('adminMinimized') === 'true';
            if (wasMinimized && window.restoreAdminSession) {
                window.restoreAdminSession();
            }
        }
    }, 800);
});

// ============================================
// GESTIÓN DE PLANES - ADMIN PANEL
// ============================================

// Cargar planes
window.adminRefreshPlans = async function() {
    const adminToken = window._adminToken;
    
    if (!adminToken) {
        if (window.showAlert) window.showAlert('Sesion Requerida', 'No hay sesión de admin activa', 'error');
        return;
    }

    try {
        const response = await fetch(`${window.WORKER_URL}/api/pricing-plans`);
        const data = await response.json();

        if (!data.success) {
            if (window.showAlert) window.showAlert('Error al Cargar', data.error || 'Error al cargar planes', 'error');
            return;
        }

        adminPlansList = Array.isArray(data.plans) ? data.plans : [];
        adminPlansPage = 1;
        renderPlansPage(adminPlansList);
    } catch (error) {
        if (window.showAlert) window.showAlert('Error al Cargar', 'Error al cargar planes', 'error');
    }
};

// Renderizar tabla de planes
function renderPlansPage(plans) {
    const total = plans.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_PLANS_PAGE_SIZE));
    adminPlansPage = clampPage(adminPlansPage, totalPages);
    const start = (adminPlansPage - 1) * ADMIN_PLANS_PAGE_SIZE;
    const pageItems = plans.slice(start, start + ADMIN_PLANS_PAGE_SIZE);

    renderPlansTable(pageItems, total);

    const pagination = ensureAdminPagination('plansPanel', 'plansPagination');
    renderPaginationControls(
        pagination,
        adminPlansPage,
        totalPages,
        () => { adminPlansPage -= 1; renderPlansPage(plans); },
        () => { adminPlansPage += 1; renderPlansPage(plans); }
    );
}

function renderPlansTable(plans, totalCount = null) {
    const tbody = document.getElementById('plansTableBody');
    
    if (!tbody) return;

    const total = totalCount !== null ? totalCount : plans.length;

    if (!plans || total === 0) {
        tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;padding:20px;">No hay planes creados</td></tr>';
        return;
    }

    tbody.innerHTML = plans.map(plan => {
        const statusBadge = plan.is_active == 1 
            ? '<span style="color:#10b981;">✅ Activo</span>' 
            : '<span style="color:#ef4444;">❌ Inactivo</span>';
        
        const price = parseFloat(plan.price_monthly).toFixed(2);
        const currency = plan.currency === 'EUR' ? '€' : '$';

        return `
            <tr>
                <td>${plan.sort_order}</td>
                <td><strong>${plan.plan_name}</strong></td>
                <td>${plan.plan_display_name}</td>
                <td>${currency}${price}</td>
                <td>${plan.currency}</td>
                <td style="font-size:11px;">${plan.stripe_price_id || '-'}</td>
                <td>${statusBadge}</td>
                <td>
                    <button onclick="adminEditPlan('${plan.id}')" class="btn-secondary" style="padding:6px 12px; font-size:12px;">✏️ Editar</button>
                    <button onclick="adminDeletePlan('${plan.id}')" class="btn-danger" style="padding:6px 12px; font-size:12px;">🗑️ Eliminar</button>
                </td>
            </tr>
        `;
    }).join('');
}

// Crear nuevo plan
window.adminCreatePlan = function() {
    if (window.demoGate && window.demoGate('create_plan', 'Crear Plan')) {
        return;
    }
    document.getElementById('planEditTitle').textContent = 'Crear Nuevo Plan';
    document.getElementById('editPlanId').value = '';
    document.getElementById('editPlanName').value = '';
    document.getElementById('editPlanDisplayName').value = '';
    document.getElementById('editPlanPrice').value = '0.00';
    document.getElementById('editPlanCurrency').value = 'EUR';
    document.getElementById('editStripePriceId').value = '';
    document.getElementById('editPlanFeatures').value = '';
    document.getElementById('editPlanSortOrder').value = '0';
    document.getElementById('editPlanActive').value = '1';
    
    const modal = document.getElementById('planEditModal');
    if (modal) {
        modal.style.display = 'flex';
    }
};

// Editar plan existente
window.adminEditUser = function(userId) {
    const user = adminUsers.find(u => u.id === userId);
    if (!user) return;
    
    const modal = document.createElement('div');
    modal.className = 'admin-action-modal';
    modal.innerHTML = `
        <div class="admin-action-content">
            <h3>Cambiar Plan de Usuario</h3>
            <p><strong>Usuario:</strong> ${user.email}</p>
            <p><strong>Plan actual:</strong> ${user.plan}</p>
            
            <div class="form-group">
                <label>Seleccionar nuevo plan:</label>
                <select id="newPlanSelect" class="admin-select">
                    <option value="free" ${user.plan === 'FREE' ? 'selected' : ''}>FREE</option>
                    <option value="pro" ${user.plan === 'PRO' ? 'selected' : ''}>PRO</option>
                    <option value="unlimited" ${user.plan === 'UNLIMITED' ? 'selected' : ''}>UNLIMITED</option>
                </select>
            </div>

            <div class="form-group" id="durationGroupUser">
                <label>Duración:</label>
                <select id="newPlanDurationSelect" class="admin-select">
                    <option value="1">1 día (prueba)</option>
                    <option value="7">7 días (1 semana)</option>
                    <option value="30" selected>30 días (1 mes)</option>
                    <option value="90">90 días (3 meses)</option>
                    <option value="180">180 días (6 meses)</option>
                    <option value="365">365 días (1 año)</option>
                </select>
            </div>
            
            <div class="modal-actions">
                <button onclick="confirmChangePlan('${userId}')" class="btn-primary">Guardar Cambios</button>
                <button onclick="closeActionModal()" class="btn-secondary">Cancelar</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);

    document.getElementById('newPlanSelect').addEventListener('change', function() {
        const durationGroup = document.getElementById('durationGroupUser');
        if (this.value === 'free') {
            durationGroup.style.display = 'none';
        } else {
            durationGroup.style.display = 'block';
        }
    });
};
// Guardar cambios del plan
window.savePlanChanges = async function(event) {
    event.preventDefault();
    
    const adminToken = window._adminToken;
    
    if (!adminToken) {
        if (window.showAlert) window.showAlert('Sesion Requerida', 'No hay sesión de admin activa', 'error');
        return;
    }

    const planId = document.getElementById('editPlanId').value;
    const planName = document.getElementById('editPlanName').value.trim();
    const planDisplayName = document.getElementById('editPlanDisplayName').value.trim();
    const priceMonthly = parseFloat(document.getElementById('editPlanPrice').value);
    const currency = document.getElementById('editPlanCurrency').value;
    const stripePriceId = document.getElementById('editStripePriceId').value.trim();
    const featuresText = document.getElementById('editPlanFeatures').value;
    const sortOrder = parseInt(document.getElementById('editPlanSortOrder').value);
    const isActive = parseInt(document.getElementById('editPlanActive').value);

    // Convertir características a array
    const features = featuresText.split('\n').map(f => f.trim()).filter(f => f.length > 0);

    try {
        const response = await fetch(`${window.WORKER_URL}/api/admin/pricing-plans`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: planId || undefined,
                plan_name: planName,
                plan_display_name: planDisplayName,
                price_monthly: priceMonthly,
                currency: currency,
                stripe_price_id: stripePriceId || null,
                features: features,
                is_active: isActive,
                sort_order: sortOrder
            })
        });

        const data = await response.json();

        if (!data.success) {
            if (window.showAlert) window.showAlert('Error al Guardar', data.error || 'Error al guardar plan', 'error');
            return;
        }

        if (window.showAlert) window.showAlert(planId ? 'Plan Actualizado' : 'Plan Creado', planId ? 'Plan actualizado correctamente' : 'Plan creado correctamente', 'success');
        closePlanEditModal();
        window.adminRefreshPlans();
    } catch (error) {
        if (window.showAlert) window.showAlert('Error al Guardar', 'Error al guardar plan', 'error');
    }
};

// Eliminar plan
window.adminDeletePlan = async function(planId) {
    const adminToken = window._adminToken;
    
    if (!adminToken) {
        if (window.showAlert) window.showAlert('Sesion Requerida', 'No hay sesión de admin activa', 'error');
        return;
    }

    const confirmed = window.showConfirm
        ? await window.showConfirm({
            title: 'Desactivar plan',
            message: '¿Estás seguro de que quieres desactivar este plan?',
            confirmText: 'Desactivar',
            cancelText: 'Cancelar',
            type: 'warning'
        })
        : false;

    if (!confirmed) return;

    try {
        const response = await fetch(`${window.WORKER_URL}/api/admin/pricing-plans/${planId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${adminToken}`
            }
        });

        const data = await response.json();

        if (!data.success) {
            if (window.showAlert) window.showAlert('Error al Eliminar', data.error || 'Error al eliminar plan', 'error');
            return;
        }

        if (window.showAlert) window.showAlert('Plan Desactivado', 'Plan desactivado correctamente', 'success');
        window.adminRefreshPlans();
    } catch (error) {
        if (window.showAlert) window.showAlert('Error al Eliminar', 'Error al eliminar plan', 'error');
    }
};

// Cerrar modal de edición
window.closePlanEditModal = function() {
    const modal = document.getElementById('planEditModal');
    if (modal) {
        modal.style.display = 'none';
    }
};

// ============================================
// SINCRONIZACIÓN MT4/MT5
// ============================================

window.adminRefreshInstallations = async function() {
    const token = window._adminToken;
    
    if (!token) {
        if (window.showAlert) window.showAlert('No hay sesión de admin activa', 'error');
        return;
    }

    const tbody = document.getElementById('installationsTableBody');
    if (!tbody) return;
    
    tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;color:#90a4ae;">🔄 Cargando instalaciones...</td></tr>';

    try {
        const result = await adminQuery(
            `SELECT *
             FROM installations
             LIMIT 200`,
            []
        );

        const rows = (result?.rows || []).slice();
        const getSortValue = (inst) => {
            const raw = inst.created_at || inst.installed_at || inst.last_sync || inst.updated_at;
            if (!raw) return 0;
            const dt = new Date(raw);
            return isNaN(dt.getTime()) ? 0 : dt.getTime();
        };
        rows.sort((a, b) => getSortValue(b) - getSortValue(a));
        adminInstallationsList = rows;
        adminInstallationsPage = 1;
        renderInstallationsPage(adminInstallationsList);
        return;
    } catch (error) {
        // Fallback al endpoint legacy si /api/execute falla
        try {
            const response = await fetch(`${getAdminWorkerUrl()}/api/admin/installations`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            if (data.success) {
                adminInstallationsList = Array.isArray(data.installations) ? data.installations : [];
                adminInstallationsPage = 1;
                renderInstallationsPage(adminInstallationsList);
                return;
            }
            throw new Error(data.message || 'Error al cargar instalaciones');
        } catch (fallbackError) {
            tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;padding:20px;color:#ff5252;">⚠️ No se pudo cargar instalaciones</td></tr>';
            if (typeof showAdminNotification === 'function') {
                showAdminNotification('Error al cargar instalaciones', 'error');
            } else if (window.showNotification) {
                window.showNotification('Error al cargar instalaciones', 'error', 3000);
            }
            // fallback failed
        }
    }
};

function getPlatformFromInstallationId(installationId) {
    if (!installationId) return 'N/A';
    const parts = String(installationId).split('_');
    const platform = parts[1] ? parts[1].substring(0, 3).toUpperCase() : 'MT4';
    return platform === 'MT5' ? 'MT5' : 'MT4';
}

function renderInstallationsPage(installations) {
    const total = installations.length;
    const totalPages = Math.max(1, Math.ceil(total / ADMIN_INSTALLATIONS_PAGE_SIZE));
    adminInstallationsPage = clampPage(adminInstallationsPage, totalPages);
    const start = (adminInstallationsPage - 1) * ADMIN_INSTALLATIONS_PAGE_SIZE;
    const pageItems = installations.slice(start, start + ADMIN_INSTALLATIONS_PAGE_SIZE);

    renderInstallationsTable(pageItems, total);

    const pagination = ensureAdminPagination('syncPanel', 'installationsPagination');
    renderPaginationControls(
        pagination,
        adminInstallationsPage,
        totalPages,
        () => { adminInstallationsPage -= 1; renderInstallationsPage(installations); },
        () => { adminInstallationsPage += 1; renderInstallationsPage(installations); }
    );
}

function renderInstallationsTable(installations, totalCount = null) {
    const tbody = document.getElementById('installationsTableBody');
    if (!tbody) return;

    const total = totalCount !== null ? totalCount : installations.length;

    if (!installations || total === 0) {
        tbody.innerHTML = `
            <tr>
                <td colspan="7" style="text-align:center;padding:40px 20px;">
                    <div style="color:#94a3b8;font-size:1.1rem;margin-bottom:8px;">📊 Sin sincronizaciones activas</div>
                    <div style="color:#64748b;font-size:0.9rem;">No hay instalaciones de MT4/MT5 registradas en el sistema.</div>
                </td>
            </tr>
        `;
        return;
    }

    tbody.innerHTML = installations.map(inst => {
        const status = String(inst.status || '').toLowerCase();
        const statusClass = status === 'active' ? 'status-active' : 'status-inactive';
        const statusText = status === 'active' ? 'Activo' : 'Inactivo';
        const platform = inst.platform || getPlatformFromInstallationId(inst.installation_id);
        const platformIcon = platform === 'MT5' ? '📈' : '📊';
        const confirmed = inst.confirmed === 1 || inst.confirmed === '1' ? 'Sí' : 'No';
        const account = inst.account ? `#${inst.account}` : 'N/A';
        const broker = inst.broker || 'N/A';
        const server = inst.server || 'N/A';
        const userLabel = inst.user_email || inst.user_id || 'N/A';
        
        return `
            <tr>
                <td data-label="Usuario">${escapeHtml(userLabel)}</td>
                <td data-label="Cuenta">${escapeHtml(account)}</td>
                <td data-label="Broker / Servidor">${escapeHtml(broker)}<br><span style="color:#64748b;">${escapeHtml(server)}</span></td>
                <td data-label="Plataforma">${platformIcon} ${escapeHtml(platform)}</td>
                <td data-label="Estado"><span class="status-badge ${statusClass}">${statusText}</span></td>
                <td data-label="Confirmada">${confirmed}</td>
                <td data-label="Creada">${inst.created_at ? formatDateTime(inst.created_at) : (inst.installed_at ? formatDateTime(inst.installed_at) : 'N/A')}</td>
            </tr>
        `;
    }).join('');
}

// Helper: format date and time
function formatDateTime(dateString) {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Fecha inválida';
        
        const dateOpts = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const timeOpts = { hour: '2-digit', minute: '2-digit' };
        
        return date.toLocaleDateString('es-ES', dateOpts) + ' ' + date.toLocaleTimeString('es-ES', timeOpts);
    } catch (e) {
        return 'Fecha inválida';
    }
}

// Helper: format date only
function formatDate(dateString) {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Fecha inválida';
        
        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
    } catch (e) {
        return 'Fecha inválida';
    }
}

// Helper: escape HTML to prevent XSS
function escapeHtml(text) {
    if (!text) return '';
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return String(text).replace(/[&<>"']/g, m => map[m]);
}


